<template>
  <header class="main-header">
    <span class="logo-mini">
      <a href="/"><img src="/static/img/bi-logo-archea-biogas2.svg" alt="Logo" class="img-responsive center-block logo"></a>
    </span>
    <!-- Header Navbar -->
    <nav class="navbar navbar-static-top" role="navigation">
      <!-- Sidebar toggle button-->
      <a href="javascript:;" class="sidebar-toggle" data-toggle="offcanvas" role="button">
        <span class="sr-only">Toggle navigation</span>
      </a>

      <!-- Navbar Right Menu -->
      <div class="navbar-custom-menu">
        <ul class="nav navbar-nav">
          <languages-menu></languages-menu>
          <notifications-menu></notifications-menu>
          <user-menu :user="user"></user-menu>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
import { mapState } from 'vuex'
import MessagesMenu from './MessagesMenu'
import NotificationsMenu from './NotificationsMenu'
import LanguagesMenu from './LanguagesMenu'
import TasksMenu from './TasksMenu'
import UserMenu from './UserMenu'

export default {
  name: 'DashHeader',
  components: {
    MessagesMenu,
    LanguagesMenu,
    NotificationsMenu,
    TasksMenu,
    UserMenu
  },
  props: ['user'],
  computed: {
    ...mapState([
      'userInfo'
    ]),
    demo () {
      return {
        displayName: this.$store.state.user.displayName,
        avatar: '../static/img/users.png',
        email: this.$store.state.user.email
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// DashHeader.vue?6f1bcc0b